import { useEffect, useState } from "react"
import ConfigVideoModal from "./configVideoModal";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import AdminToast from "../../../core/admin/adminToast";
import AdminModal from "../../../core/admin/adminModal";
import AdminPage from "../../../core/admin/adminPage";
import AdminCard from "../../../core/admin/adminCard";
import AdminButton from "../../../core/admin/adminButton";
import AdminBadge from "../../../core/admin/adminBadge";
import AdminSwitch from "../../../core/admin/adminSwitch";
import AdminDetails from "../../../core/admin/adminDetails";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import { ExternalLinkIcon, PencilIcon } from "../../../../img/svg/adminIcons";
import HeaderHome from "./headerHome";

export interface IVideo {
    id: string;
    link: string;
    title: string;
    description: string;
    active: boolean;
}

export default function AdminHomeConfigs() {

    const [config, setConfig] = useState(false);
    const [video, setVideo] = useState<IVideo | null>(null);
    const [loading, setLoading] = useState(false);
    const [goodToast, setGoodToast] = useState(false);
    const [badToast, setBadToast] = useState(false);
    const [activateModal, setActivateModal] = useState(false);

    useEffect(() => {
        getVideo();
    }, [])

    const getVideo = async () => {
        try {
            setLoading(true);
            const docSnap = await getDocs(collection(db, "videos"));
            if (docSnap.empty) {
                setVideo(null);
                setLoading(false);
                return null;
            }
            const docs = docSnap.docs.map(d => {
                return {
                    id: d.id,
                    link: d.data()?.link,
                    title: d.data()?.title,
                    description: d.data()?.description,
                    active: d.data()?.active,
                }
            })
            setVideo(docs.filter(d => d?.link)[0]);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setBadToast(true);
        }
    }

    const handleActivation = async () => {
        try{
            if(!video){
                return null;
            }
            setLoading(true);
            const docRef = doc(db, "videos", video.id);
            await updateDoc(docRef, { active: !video.active });
            setLoading(false);
            setGoodToast(true);
            setActivateModal(false);
            getVideo();
        }catch(error){
            console.log(error);
            setLoading(false);
            setBadToast(true);
        }
    }

    return (
        <AdminPage title="Home" description="Configure a imagem do header e o vídeo exibidos na página inicial do site.">
            <HeaderHome />
            <AdminCard
                title={<>Vídeo {!loading ? video?.active ? <AdminBadge tone="success" dot>Visível na home</AdminBadge> : <AdminBadge dot>Invisível na home</AdminBadge> : null}</>}
                description="Informações sobre o vídeo disponível na página inicial do site"
                actions={
                    !loading ?
                        <>
                            {
                                video ?
                                    <AdminSwitch on={video?.active} onClick={() => setActivateModal(true)} label={video?.active ? "Ativo" : "Inativo"} />
                                    : null
                            }
                            <AdminButton variant="secondary" icon={<PencilIcon width="14px" />} onClick={() => setConfig(true)}>Configurar</AdminButton>
                        </>
                        : null
                }
            >
                {
                    loading ?
                        <AdminLoading />
                        :
                        <AdminDetails
                            columns={1}
                            items={[
                                { label: "Link", value: video?.link ? <a href={video.link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 font-semibold text-gray-900 underline decoration-secondary underline-offset-2 break-all">{video.link} <ExternalLinkIcon width="14px" /></a> : <span className="text-gray-400">Nenhum link configurado</span> },
                                { label: "Título", value: video?.title || <span className="text-gray-400">Nenhum título configurado</span> },
                                { label: "Descrição", value: video?.description || <span className="text-gray-400">Nenhuma descrição configurada</span> },
                            ]}
                        />
                }
            </AdminCard>
            {
                config ?
                    <ConfigVideoModal video={video} close={() => setConfig(false)} refresh={getVideo} goodToast={() => setGoodToast(true)} badToast={() => setBadToast(true)} />
                    : null
            }
            {
                activateModal ?
                    <AdminModal
                        close={() => setActivateModal(false)}
                        size="sm"
                        title={video?.active ? "Deseja desativar o vídeo?" : "Deseja ativar o vídeo?"}
                        footer={
                            <>
                                <AdminButton variant="secondary" disabled={loading} onClick={() => setActivateModal(false)}>Cancelar</AdminButton>
                                <AdminButton variant={video?.active ? "danger" : "primary"} loading={loading} onClick={handleActivation}>Sim</AdminButton>
                            </>
                        }
                    >
                        <p className="text-sm text-gray-600">{video?.active ? "A seção do vídeo na página inicial do site deixará de ficar visível" : "A seção do vídeo na página inicial do site ficará visível"}</p>
                    </AdminModal>
                    : null
            }
            <AdminToast message="Vídeo atualizado!" toast={goodToast} setToast={setGoodToast} tone="success" />
            <AdminToast message="Erro!" toast={badToast} setToast={setBadToast} tone="danger" />
        </AdminPage>
    )
}
